import { helpers } from 'vuelidate/lib/validators'

const isEmptyObject = value => {
  return value === null || value === '' || value === undefined
}

export const optional = boolFieldName => (value, vm) => {
  let isOptional = vm[boolFieldName]
  return isOptional || !isEmptyObject(value)
}

export const password = helpers.regex('password', /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[!@#$])[0-9a-zA-Z!@#$]{8,}$/)

// 下方的非共用，应该移除，只在使用的地方定义
//经度范围：-180.000000~180.000000,浮点数不多余6位
const longitude = helpers.regex('longitude', /^-?((0|1?[0-7]?[0-9]?)(([.][0-9]{1,6})?)|180(([.][0]{1,6})?))$/)

// 纬度范围：-90.000000~90.000000,浮点数不多余6位
const latitude = helpers.regex('latitude', /^-?((0|[1-8]?[0-9]?)(([.][0-9]{1,6})?)|90(([.][0]{1,6})?))$/)

export { longitude, latitude }
